export default __webpack_public_path__ + "static/media/643.28ff914a.png";